import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IProcurementPlanLog } from 'types/procurementPlans/procurementPlanLogs'

export const procurementPlanLogsApi = createApi({
  reducerPath: 'procurementPlanLogs',
  baseQuery,
  endpoints: (builder) => ({
    procurementPlanLogs: builder.query<IProcurementPlanLog[], void>({
      query: () => ({
        url: '/procurement-plan-logs',
      }),
    }),

    procurementPlanLog: builder.query<IProcurementPlanLog, IdParams>({
      query: ({ id }) => `/procurement-plan-logs/${id}`,
    }),

    deleteProcurementPlanLog: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/procurement-plan-logs/${id}`,
        method: 'delete',
      }),
    }),

    updateProcurementPlanLog: builder.mutation<
      IProcurementPlanLog,
      { id: string; planLog: IProcurementPlanLog }
    >({
      query: ({ id, planLog }) => ({
        url: `/procurement-plan-logs/${id}`,
        body: planLog,
        method: 'put',
      }),
    }),

    createProcurementPlanLog: builder.mutation<
      IProcurementPlanLog,
      Partial<IProcurementPlanLog>
    >({
      query: (body) => ({
        url: '/procurement-plan-logs',
        method: 'post',
        body,
      }),
    }),
  }),
})

export const {
  useProcurementPlanLogQuery,
  useProcurementPlanLogsQuery,
  useCreateProcurementPlanLogMutation,
  useUpdateProcurementPlanLogMutation,
  useDeleteProcurementPlanLogMutation,
} = procurementPlanLogsApi
